module.exports = __webpack_public_path__ + "static/media/edit-order-info.ed526634.svg";